import { useRef, useEffect, useState, memo, useCallback } from "react";
import cn from "classnames";
// import { useMousePosition } from "@hooks/useMousePosition";
import { useStore } from "@hooks/useZustandProvider";
import EmptySlider from "@components/cms/EmptySlider/EmptySlider";
import s from "./Slider.module.scss";

const Slider = ({
  startPadding,
  className,
  slidesCount,
  render = () => { },
  autoScroll = false,
  interval = 3000,
  speed = 500,
  cursorNotice = 'Double click to edit slider',
  collectionType,
}) => {
  // const { isWidget } = useMousePosition();
  const { cms, updateCollectionType } = useStore();
  const { isEditMode } = cms.uiOptions;
  const { isWidget } = cms.page;
  const { isWidgetEditing } = cms.widget;
  const [currentSlide, setCurrentSlide] = useState(1);
  const scrollerRef = useRef(null);
  const buttonPrevRef = useRef(null);
  const buttonNextRef = useRef(null);

  const classes = cn(
    s.slider,
    startPadding && s.startPadding,
    !slidesCount && s.emptySlider,
    slidesCount && className,
  );

  const handleClickToEdit = useCallback((e) => {

    switch (e.detail) {
      // case 1: // click
      // break;
      case 2: // double click
        updateCollectionType(e);
      // break;
      // case 3: // triple click
      // break;
    }
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);
  const autoScrollRef = useRef(null);

  const isAtStart = currentIndex === 0;
  const isAtEnd = currentIndex === slidesCount - 1;

  const smoothScroll = (element, target, duration) => {
    const start = element.scrollLeft;
    const change = target - start;
    let startTime = null;

    const animateScroll = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const timeElapsed = timestamp - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      element.scrollLeft = start + change * progress;

      if (timeElapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  const updateIndex = (newIndex) => {
    setCurrentIndex(newIndex);

    if (autoScroll) {
      restartAutoScroll();
    }

    const slider = sliderRef.current;
    const newOffset = slider.scrollWidth / slidesCount * newIndex;
    smoothScroll(slider, newOffset, speed);
  };

  const nextSlide = () => {
    console.log('nextSlide');
    if (!isAtEnd) {
      updateIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    console.log('nextSlide');
    if (!isAtStart) {
      updateIndex(currentIndex - 1);
    }
  };

  const restartAutoScroll = useCallback(() => {
    clearInterval(autoScrollRef.current);
    autoScrollRef.current = setInterval(() => {
      if (isAtEnd) {
        updateIndex(0);
      } else {
        nextSlide();
      }
    }, interval);
  }, [currentIndex, interval, isAtEnd]);

  useEffect(() => {
    if (autoScroll) {
      restartAutoScroll();
    }
    return () => clearInterval(autoScrollRef.current);
  }, [autoScroll, restartAutoScroll]);

  if (!slidesCount) {
    return isEditMode ? (
      <EmptySlider
        cursorNotice={cursorNotice}
        collectionType={collectionType}
        onClick={handleClickToEdit}
      />
    ) : null;
  }

  return (
    <div
      className={classes}
      {...(isEditMode && !(!isWidgetEditing && isWidget)
        ? {
          "data-collection-type": collectionType,
          "data-cursor-notice": cursorNotice,
          onClick: handleClickToEdit,
        }
        : {})}
    >
      {render({
        isWait: false,
        cursorNotice,
        interval,
        slidesCount,
        isEnd: isAtEnd,
        isStart: isAtStart,
        currentSlide: currentIndex,
        scrollerRef: sliderRef,
        buttonPrevRef,
        buttonNextRef,
        nextSlide,
        prevSlide,
      })}
    </div>
  );
};

export default memo(Slider);
